<div class="favourite-card">
    <div class="title-bar">
        <a [routerLink]="['/siteDetails', siteDetails?.Identifier]">
            <span class="title">{{siteDetails?.SiteName ?? ""}}</span>
        </a>  
                     
        <app-favourite-icon [showLabel]="false" 
            [siteName]="siteDetails?.SiteName"
            [siteIdentifier]="siteDetails?.Identifier ?? ''"
            (favouriteIconClickedEvent)="onFavouriteIconClicked($event)" >
        </app-favourite-icon>
    </div>
    <div class="nsw-card__image" style="width:100%;">
        <img [src]="siteImage" [alt]="siteDetails?.SiteName">
    </div> 
    <app-site-info-widget *ngIf="sitePopupInfo?.Identifier"                   
        [isFavouriteScreen]="true" 
        [sitePopupInfo]="sitePopupInfo!">
    </app-site-info-widget>      
</div>

